export const MAX_NUMBER_OF_LABELS = 100;

export const NUMBER_OF_LABELS_TO_SHOW_ON_VIDEO_CARD = 3;
